/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates some simple date formats to be used.
 */
export var DateFormats = /*@__PURE__*/ (function (DateFormats) {
    /**
     * A standard short date format is used.
     */
    DateFormats[DateFormats["DateShort"] = 0] = "DateShort";
    /**
     * A standard long date format is used.
     */
    DateFormats[DateFormats["DateLong"] = 1] = "DateLong";
    return DateFormats;
})({});
/**
 * @hidden
 */
export var DateFormats_$type = /*@__PURE__*/ markEnum('DateFormats', 'DateShort,0|DateLong,1');
//# sourceMappingURL=DateFormats.js.map
